import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Contract } from '../../model/contract';
import { Money } from '../../../core/model/money';
import { Tenant } from '../../model/tenant';
import { TenantService } from '../../service/data/tenant.service';
import { AutoCompleteSelectionItem } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';
import { SelectionItem } from '../../../core/component/select/select.component';
import { CreditorResponsibility } from '../../model/const/enums';
import { Subscription } from 'rxjs';
import { ContractSecurity } from '../../model/contract-security';

@Component({
    selector: 'app-contract-security',
    templateUrl: './contract-security.component.html',
    styleUrls: ['./contract-security.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractSecurityComponent implements OnDestroy {
  addGuarantor() {
    this.securities.push(this.createSecurityForm(null));
  }
  delete(index: number) {
    this.securities.removeAt(index);
    this.form.markAsDirty();
  }
  constructor(public tenantService: TenantService, private _fcf: FormControlExFactory, private readonly _fb: FormBuilder) {}

  ngOnDestroy(): void {
    if (this._sub) {
      this._sub.unsubscribe();
    }
  }

  @Input() dataContext: Contract;
  @Input() form: FormGroup;

  CreditorResponsibility = CreditorResponsibility;
  securities: FormArray;

  tenant: Tenant;
  private _sub = new Subscription();

  contactSelected(value: AutoCompleteSelectionItem): void {
    this.tenant = value ? value.data : null;
  }

  onTenantSelected(item: AutoCompleteSelectionItem, ownerForm: FormGroup) {
    const tenant = item?.data || null;
    ownerForm.markAsDirty();
    ownerForm.controls['contactId'].setValue(tenant?.id);
  }

  get civicOrOrganizationNo(): string {
    return this.tenant && this.tenant.contactIdentification ? this.tenant.contactIdentification : '';
  }

  get creditorEmail(): string {
    return this.tenant && this.tenant.email ? this.tenant.email : '';
  }

  get creditorPhone(): string {
    return this.tenant && this.tenant.phone ? this.tenant.phone : '';
  }

  get creditorHasCivicOrOrganizationNo(): boolean {
    return this.civicOrOrganizationNo !== '';
  }

  get creditorHasEmail(): boolean {
    return this.creditorEmail !== '';
  }

  get creditorHasPhone(): boolean {
    return this.creditorPhone !== '';
  }
  get showCreditorDescription(): boolean {
    return this.form.controls['creditorResponsibility'].value == CreditorResponsibility.Limited;
  }
  responsibilitySelection: SelectionItem[] = [
    new SelectionItem('LEASE_AGREEMENT.CREDITOR_FULL_RESPONSIBILITY', CreditorResponsibility.Full),
    new SelectionItem('LEASE_AGREEMENT.CREDITOR_LIMITED_RESPONSIBILITY', CreditorResponsibility.Limited),
  ];
  ngOnInit() {
    this.form.addControl(
      'depositAmount',
      this._fcf.create(
        'LEASE_AGREEMENT.DEPOSIT_AMOUNT',
        new Money(this.dataContext.currencyCode, this.dataContext.depositAmount ? this.dataContext.depositAmount.amount : null)
      )
    );
    this.form.addControl('depositComment', this._fcf.create('LEASE_AGREEMENT.DEPOSIT_COMMENT', this.dataContext.depositComment));
    this.form.addControl('securities', this.createSecuritiesForms());
  }

  createSecurityForm(owner: ContractSecurity): FormGroup {
    var form = this._fb.group({
      id: this._fcf.createHidden(owner ? owner?.id : null),
      contactId: this._fcf.createMandatory('LEASE_AGREEMENT.CREDITOR', owner?.contactId),
      //comment: this._fcf.create('LEASE_AGREEMENT.DEPOSIT_COMMENT', owner?.comment),
      leaseAgreementId: this._fcf.create('Kontrakt', this.dataContext?.id),
      responsibility: this._fcf.create('LEASE_AGREEMENT.CREDITOR_RESPONSIBILITY', owner?.responsibility ?? CreditorResponsibility.Full),
      comment: this._fcf.create('LEASE_AGREEMENT.CREDITOR_RESPONSIBILITY_DESC', owner?.comment),
    });
    form.controls['responsibility'].valueChanges.subscribe(val => {
      val === CreditorResponsibility.Limited ? Validators.compose([Validators.required, Validators.maxLength(500)]) : null;
    });
    return form;
  }

  createSecuritiesForms(): FormArray {
    this.securities = this._fb.array([]);
    for (let owner of this.dataContext.securities) {
      this.securities.push(this.createSecurityForm(owner));
    }
    return this.securities;
  }
}
